/**
 * Constants file for agent names
 *
 * This file defines agent name constants for use in the application.
 */

// Agent name constants
export const AGENT_NAMES = {
  // // Organization profile related agents
  // ADMIN: "adminAgent",

  // // Work related agents
  // WORK_BREAKDOWN: "workBreakdownAgent",

  // // Dashboard agent
  // DASHBOARD: "dashboardAgent",

  // // Weather demo agent
  // WEATHER: "weatherAgent",

  // // Org profile related agents
  // ORG_PROFILE: "orgProfileAgent",

  // // Hello world demo agent
  // HELLO_WORLD: "helloWorldAgent",

  // Kriya agent
  KRIYA: "kriyaSupervisorAgent", //kriyaAgent is the default agent for the Kriya project

  // Schedule optimizer agent
  SCHEDULE_OPTIMIZER: "scheduleOptimizerAgent",

  // WBS optimizer agent
  WBS_OPTIMIZER: "wbsOptimizerAgent",
} as const;

// Type for agent names to enable type safety
export type AgentName = (typeof AGENT_NAMES)[keyof typeof AGENT_NAMES];

/**
 * Validates if a string is a valid agent name
 * @param name The string to validate
 * @returns True if the name is a valid agent name, false otherwise
 */
export function isValidAgentName(name: string): name is AgentName {
  return Object.values(AGENT_NAMES).includes(name as AgentName);
}

// Default agent to use when none is specified
export const DEFAULT_AGENT = AGENT_NAMES.KRIYA;

/**
 * Get agent name from query parameter or use default
 * @param agentParam The agent name from query parameter
 * @returns A valid agent name
 */
export function getAgentName(agentParam?: string): AgentName {
  if (agentParam && isValidAgentName(agentParam)) {
    return agentParam;
  }
  return DEFAULT_AGENT;
}
